import routesConfig from '../../config/routes';
import { getRemoteMenu, getMatchMenuItem } from '@/services/session';

export interface FlatRoute {
  path: string;
  name?: string;
}

const AFFIX_PATHS = ['/home'];
const EXCLUDE_PATH_PREFIXES = ['/user/login'];

export const HOME_PATH = '/home';

/** 将根路径归一化为首页，避免 logo 跳转 / 产生空标签 */
export function normalizePathname(pathname: string): string {
  if (pathname === '/' || pathname === '') {
    return HOME_PATH;
  }
  return pathname;
}

function resolvePath(parentPath: string, path: string): string {
  if (path.startsWith('/')) {
    return path;
  }
  const base = parentPath.endsWith('/') ? parentPath.slice(0, -1) : parentPath;
  return `${base}/${path}`;
}

export function flattenRoutes(routes: any[], parentPath = ''): FlatRoute[] {
  const result: FlatRoute[] = [];
  for (const route of routes) {
    if (route.redirect || route.layout === false || !route.path) {
      continue;
    }
    const fullPath = resolvePath(parentPath, route.path);
    if (route.component && route.name) {
      result.push({ path: fullPath, name: route.name });
    }
    if (route.routes) {
      result.push(...flattenRoutes(route.routes, fullPath));
    }
  }
  return result;
}

function matchDynamicRoute(pathname: string, routePath: string): boolean {
  const routeParts = routePath.split('/').filter(Boolean);
  const pathParts = pathname.split('/').filter(Boolean);
  if (routeParts.length !== pathParts.length) {
    return false;
  }
  return routeParts.every((part, index) => part.startsWith(':') || part === pathParts[index]);
}

export function getRouteTitle(pathname: string): string {
  const normalizedPath = normalizePathname(pathname);
  const remoteMenu = getRemoteMenu();
  if (remoteMenu?.length) {
    const matched = getMatchMenuItem(normalizedPath, remoteMenu);
    const menuTitle = matched[matched.length - 1]?.name;
    if (menuTitle) {
      return menuTitle as string;
    }
  }

  const flatRoutes = flattenRoutes(routesConfig);
  const exact = flatRoutes.find((route) => route.path === normalizedPath);
  if (exact?.name) {
    return exact.name;
  }

  const pattern = flatRoutes.find((route) => matchDynamicRoute(normalizedPath, route.path));
  if (pattern?.name) {
    return pattern.name;
  }

  const segments = normalizedPath.split('/').filter(Boolean);
  return segments[segments.length - 1] || '页面';
}

export function getViewPath(pathname: string, search = ''): string {
  return `${pathname}${search}`;
}

export function isAffixPath(pathname: string): boolean {
  return AFFIX_PATHS.includes(normalizePathname(pathname));
}

export function isTagsViewExcluded(pathname: string): boolean {
  return EXCLUDE_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
